/*
 * @Author: scg
 * @Date: 2022-01-06 22:07:36
 * @LastEditTime: 2022-01-20 09:51:40
 * @LastEditors: scg
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./assets/iconfont.css"
import Vue from 'vue'
import App from './App'
import router from './router'
import languageTranslation from '@/components/languageTranslation'
// import Mint from 'mint-ui'
import { Swipe, SwipeItem } from 'mint-ui'
import 'mint-ui/lib/style.css'
import i18n from "@/langurage/i18n";

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import echarts from 'echarts'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import locale from 'element-ui/lib/locale/lang/en'

import 'leaflet/dist/leaflet.css'
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet'
import {downloadFilePic } from '@/api/getUrlBase64';
Vue.prototype.downloadFilePic = downloadFilePic;

Vue.L = Vue.prototype.$L = L

Vue.prototype.$video = Video
Vue.component('languageTranslation', languageTranslation)
// Vue.use(ElementUI)
Vue.use(ElementUI, { locale, i18n: (key, value) => i18n.t(key, value) });
// import 'mint-ui/lib/index.js'
// import {Swipe, SwipeItem} from 'mint-ui'
// Vue.use(Mint)
Vue.config.productionTip = false
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
// Vue.use(MintUI)
/* eslint-disable no-new */
// Vue.component(DatetimePicker.name, DatetimePicker)

Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)

new Vue({
  el: '#app',
  // render: h => h(App),
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js